import React, { Component } from 'react';
import ProjectRow from './ProjectTableRow';
import { ProjectsTableState } from '../ProjectsTable';
import { getSortedList } from '../utils';

interface Props {
  project: any;
  subprojectLevel?: number;
  flatTable?: boolean;
  removeLine?: () => void;
  arrangeState: ProjectsTableState;
}

interface State {
  expanded: boolean;
}

class ProjectTableLine extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { expanded: false };

    this.renderSubProjects = this.renderSubProjects.bind(this);
  }

  renderSubProjects() {
    const { project, subprojectLevel = 0, arrangeState } = this.props;

    if (!project.children || !project.children.length) return null;

    return getSortedList(project.children, arrangeState).map((p: any) =>
      <ProjectTableLine
        key={p.id}
        project={p}
        arrangeState={arrangeState}
        subprojectLevel={subprojectLevel + 1}
      />
    );
  }

  render() {
    const { project, subprojectLevel = 0, flatTable, removeLine } = this.props;
    const { expanded } = this.state;

    return (
      <div>
        <ProjectRow
          project={project}
          // {...project}
          // title={project.title}
          subprojectLevel={subprojectLevel}
          expandable={project.children && project.children.length > 0}
          expanded={expanded}
          onClick={() => this.setState({ expanded: !expanded })}
          flatTable={flatTable}
          removeLine={removeLine}
        />
        {expanded && this.renderSubProjects()}
      </div>
    );
  }
}

export default ProjectTableLine;
